import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb55a982"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "information-mgmt-edit" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#898989","font-size":"14px"} }, " 5M以下的JPEG、PNG、JPG图片，建议尺寸比例为3:2 ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#898989","font-size":"14px"} }, " 5M以下的JPEG、PNG、JPG图片，建议尺寸比例为3:2 ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#898989","font-size":"14px"} }, " 上传200MB内的视频文件 ", -1))
const _hoisted_5 = { class: "affix-box" }

import { useRoute, useRouter } from 'vue-router';
import XrkTinymce from '../../../../components/xrk/tinymce';
import { ref } from 'vue';
import {
  BaseButton,
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseFormProps,
  BaseFormRef,
  XrkMessage,
  BaseSelect,
  BaseUpload,
  createDialog
} from 'xrk-components';
import { uploadApi } from '@data-source/common/apis';
import { addOrUpdate, infoDetail } from '../data-source/apis';

type DataType = {
  id?: number;
  title: string;
  author: string;
  cover: any[];
  videoCover: any[];
  videoUrl: any[];
  videoLink: string;
  contentType: number; //是否上传视频1否2是
  content: string;
};

type RichTextFormProps = BaseFormProps<DataType>;

export default /*#__PURE__*/_defineComponent({
  __name: 'information-mgmt-edit',
  setup(__props) {

const route = useRoute();
const id: number = +route.query?.id || null;
const router = useRouter();
const baseUploadRefCover = ref();
const baseUploadRefVideoCover = ref();
const baseUploadRefVideoUrl = ref();

const BaseFormItemBaseConfig = {
  'label-width': '110px',
  'label-position': 'top'
};

const formRef = ref<BaseFormRef<DataType>>();

const onChangeUpload = key => {
  formRef.value.validateField(key);
};

// const tipsCount = ref(0);
// const beforeUploadSelect = (file: File) => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onload = function (e) {
//       const img = new Image();
//       img.onload = function () {
//         const ratio = img.width / img.height;
//         if (ratio !== 3 / 2) {
//           tipsCount.value === 0 &&
//             XrkMessage.error(`请上传宽：高比为3：2的图片`);
//           reject(`请上传宽：高比为3：2的图片`);
//           tipsCount.value++;
//         } else {
//           resolve(file);
//         }
//         setTimeout(() => {
//           tipsCount.value = 0;
//         }, 1);
//       };
//       img.src = e.target.result as any; // 设置img的src为读取后的数据URL
//     };
//     reader.readAsDataURL(file); // 读取文件内容为DataURL
//   });
// };
const onError = errorInfo => {
  XrkMessage.error(errorInfo.msg);
};

const httpRequest = ({ file }: { file: File }, key) => {
  return new Promise((resolve, reject) => {
    uploadApi({ file })
      .then(res => {
        formData.value[key][0].url = res.data.fileUrl;
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};
const onTinymceInput = v => {
  formData.value.content = v;
  formRef.value.validateField('content');
};

const formData = ref<DataType>({
  title: '',
  author: '',
  cover: [],
  videoCover: [],
  videoLink: '',
  videoUrl: [],
  contentType: 1,
  content: ''
});
const rules: RichTextFormProps['rules'] = {
  title: { required: true, message: '请输入资讯标题' },
  author: { required: true, message: '请输入作者' },
  cover: [
    {
      required: true,
      trigger: 'blur',
      validator: (_, _value, callback) => {
        if (!formData.value.cover.length) {
          return callback(new Error('请上传列表封面图'));
        }
        callback();
      }
    }
  ],
  contentType: {
    required: true,
    message: '请选择是否上传视频',
    trigger: 'change'
  },
  videoCover: [
    {
      required: true,
      trigger: 'blur',
      validator: (_, _value, callback) => {
        if (!formData.value.videoCover.length) {
          return callback(new Error('请上传视频封面图'));
        }
        callback();
      }
    }
  ],
  content: { required: true, message: '资讯正文不能为空' }
};

const initData = async () => {
  const {
    data: {
      title,
      author,
      content,
      cover,
      videoUrl,
      videoCover,
      videoLink,
      contentType
    }
  } = await infoDetail({ id, hasForm: 0 });
  formData.value.title = title;
  formData.value.author = author;
  formData.value.content = content;
  if (videoCover) {
    if (videoUrl) {
      formData.value.videoUrl = [
        {
          url: videoUrl
        }
      ];
    } else {
      formData.value.videoLink = videoLink;
    }

    formData.value.videoCover = [
      {
        url: videoCover
      }
    ];
  }
  formData.value.cover = [
    {
      url: cover
    }
  ];
  formData.value.contentType = contentType;
};

const onCancelClick = () => {
  createDialog({
    width: 350,
    title: '提示',
    showClose: true,
    content: '当前页面有未保存内容，是否继续返回',
    beforeConfirm: async done => {
      done();
      router.back();
    }
  });
};

const onSaveClick = async () => {
  await formRef.value?.validate();
  await baseUploadRefCover.value.submit();
  if (formData.value.contentType === 2) {
    await baseUploadRefVideoCover.value.submit();
    await baseUploadRefVideoUrl.value.submit();
    if (!formData.value.videoUrl.length && !formData.value.videoLink) {
      return XrkMessage.error('请上传视频文件或输入视频链接');
    }
  }

  const params = {
    ...formData.value,
    cover: formData.value.cover[0].url,
    videoCover: formData.value.videoCover[0]?.url,
    videoUrl: formData.value.videoUrl[0]?.url,
    hasForm: 0,
    id
  };
  await addOrUpdate(params);
  XrkMessage.success('保存成功');
  router.back();
};
if (id) {
  initData();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseForm), {
      style: {"flex":"1","height":"100%","box-sizing":"border-box","padding":"20px","overflow-y":"auto"},
      ref_key: "formRef",
      ref: formRef,
      "label-position": "top",
      model: formData.value,
      rules: rules,
      columnCount: 2
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseFormItem), _mergeProps(BaseFormItemBaseConfig, {
          label: "资讯标题",
          prop: "title"
        }), {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              placeholder: "请输入资讯标题",
              style: {"width":"100%"},
              modelValue: formData.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.title) = $event)),
              maxlength: 200,
              "show-word-limit": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 16),
        _createVNode(_unref(BaseFormItem), _mergeProps(BaseFormItemBaseConfig, {
          label: "资讯作者",
          prop: "author"
        }), {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              placeholder: "请输入作者",
              style: {"width":"100%"},
              modelValue: formData.value.author,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.author) = $event)),
              maxlength: 30,
              "show-word-limit": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 16),
        _createVNode(_unref(BaseFormItem), {
          style: {"flex-direction":"column"},
          label: "列表封面图",
          prop: "cover"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseUpload), {
              style: {"width":"100%"},
              ref_key: "baseUploadRefCover",
              ref: baseUploadRefCover,
              listType: "picture-card",
              accept: ['.jpg', '.png', '.jpeg'],
              limit: 1,
              limitSize: 5,
              autoUpload: true,
              onError: onError,
              httpRequest: 
            async e => {
              await httpRequest(e, 'cover');
            }
          ,
              fileList: formData.value.cover,
              "onUpdate:fileList": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.cover) = $event)),
              onChange: _cache[3] || (_cache[3] = ($event: any) => (onChangeUpload('cover')))
            }, {
              tip: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["httpRequest", "fileList"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), _mergeProps(BaseFormItemBaseConfig, {
          label: "是否上传视频",
          prop: "contentType"
        }), {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              modelValue: formData.value.contentType,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.contentType) = $event)),
              placeholder: "请选择是否上传视频",
              options: [
            { label: '是', value: 2 },
            { label: '否', value: 1 }
          ]
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 16),
        (formData.value.contentType === 2)
          ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
              key: 0,
              style: {"flex-direction":"column"},
              label: "视频封面图",
              prop: "videoCover"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseUpload), {
                  style: {"width":"100%"},
                  ref_key: "baseUploadRefVideoCover",
                  ref: baseUploadRefVideoCover,
                  listType: "picture-card",
                  accept: ['.jpg', '.png', '.jpeg'],
                  limit: 1,
                  limitSize: 5,
                  autoUpload: true,
                  onError: onError,
                  httpRequest: 
            async e => {
              await httpRequest(e, 'videoCover');
            }
          ,
                  fileList: formData.value.videoCover,
                  "onUpdate:fileList": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.videoCover) = $event)),
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (onChangeUpload('videoCover')))
                }, {
                  tip: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["httpRequest", "fileList"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (formData.value.contentType === 2)
          ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
              key: 1,
              style: {"flex-direction":"column"},
              label: "视频文件",
              prop: "videoUrl"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseUpload), {
                  style: {"width":"100%"},
                  ref_key: "baseUploadRefVideoUrl",
                  ref: baseUploadRefVideoUrl,
                  disabled: !!formData.value.videoLink,
                  accept: ['.mp4'],
                  limit: 1,
                  limitSize: 200,
                  autoUpload: true,
                  onError: onError,
                  httpRequest: 
            async e => {
              await httpRequest(e, 'videoUrl');
            }
          ,
                  fileList: formData.value.videoUrl,
                  "onUpdate:fileList": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.videoUrl) = $event)),
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (onChangeUpload('videoUrl')))
                }, {
                  tip: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["disabled", "httpRequest", "fileList"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (formData.value.contentType === 2)
          ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
              key: 2,
              style: {"flex-direction":"column"},
              label: "视频链接",
              prop: "videoLink"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  disabled: formData.value.videoUrl.length > 0,
                  placeholder: "请输入视频链接",
                  style: {"width":"100%"},
                  modelValue: formData.value.videoLink,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.videoLink) = $event))
                }, null, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(BaseFormItem), _mergeProps(BaseFormItemBaseConfig, {
          label: "资讯正文",
          prop: "content",
          style: {"grid-column-start":"1","grid-column-end":"3"}
        }), {
          default: _withCtx(() => [
            _createVNode(_unref(XrkTinymce), {
              style: {"width":"100%"},
              value: formData.value.content,
              onInput: onTinymceInput,
              limitImgSize: [1000, 1500]
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 16)
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancelClick
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        type: "primary",
        onClick: onSaveClick
      }, {
        default: _withCtx(() => [
          _createTextVNode("保存")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})